export function getExcelDownloadFileName (documentTitle: string, fileType: string | null | undefined): string {
    const normalizedFileType = normalizeExcelFileType(fileType) ?? 'xlsx';
    return `${documentTitle}.${normalizedFileType}`;
}

export function getExcelFileTypeFromName (fileName: string | null | undefined): string | null {
    if (!fileName) return null;

    const lastDotIndex = fileName.lastIndexOf('.');
    if (lastDotIndex === -1 || lastDotIndex === fileName.length - 1) return null;

    return normalizeExcelFileType(fileName.slice(lastDotIndex + 1));
}

export function normalizeExcelFileType (fileType: string | null | undefined): string | null {
    if (typeof fileType !== 'string') return null;

    const normalized = fileType.trim().replace(/^\./, '').toLowerCase();
    if (!normalized || normalized === 'null' || normalized === 'undefined') return null;

    return normalized;
}
